module.exports = __webpack_public_path__ + "static/media/png.62ac70c4.svg";